"use client";
import React, { useState } from 'react';

//=== Packages == //
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import Image from 'next/image';


import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

//=== Images == //
import product from '../media/Session-img.png';
import WhatshotIcon from '../media/whatshot.svg';



//=== Components == //
import Buttons from "../compononents/Button/Button";




export default function PaymentPlan() {

  const [alignment, setAlignment] = React.useState('1');
  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  const shoppingData = [
    {
      img: product,
      title: "Quranic Arabic Language Level -1",
      description: "Ustazah Nurjahan Rosul (Moyna)",
      totalprice: "Total track price: $2400",
    },
  ];

  const planData = [
    {
      value:"1",
      plantype: "Pay in full ",
      Plantime: "- One-time payment of:",
      newprice: "$2000",
      oldprice: "$2400",
      mostpopular:true,
      save:true,
      saveamount:"$400",
      //onClick:onClick,
    },
    {
      value:"2",
      plantype: "Pay in full ",
      Plantime: "- One-time payment of:",
      newprice: "$2000",
      oldprice: "$2400",
      save:true,
      saveamount:"$400",
      //onClick:onClick,
    },
    {
      value:"3",
      plantype: "Pay in full ",
      Plantime: "- One-time payment of:",
      newprice: "$2000",
    },
  ];




  return (

    <>
      <div className="PM_Plan_Prod_Listng">

        {shoppingData.map((item, i) => (
          <div className='PM_PlanProdList'>
            <div className='PM_PlanProdList_Left'>
              <div className='PM_PlanProdImg'><Image src={item.img} /></div>
              <div className='PM_PlanProdDetails'>
                <h1>{item.title}</h1>
                <p>{item.description}</p>
                <h2>{item.totalprice}</h2>
              </div>
            </div>
          </div>
        ))}

      </div>

      <div className='PM_SelectPlan'>
        <div className='PM_SelectPlanTitle'>Select a plan*</div>
        <ToggleButtonGroup
          value={alignment}
          exclusive
          onChange={handleAlignment}
          aria-label="text alignment"
        >

          {planData.map((item, i) => (
            <ToggleButton value={item.value} onClick={item.onClick}>
              <div className='PM_Plan_Content'>

                <div className='PM_Plan_Left_Col'>
                  <div className='PM_Plan_Detials'>{item.plantype}<span>{item.Plantime}</span></div>
                  <div className='PM_Plan_Price'>
                    <h2>{item.newprice}</h2>
                    <h3>{item.oldprice}</h3>
                    {item.mostpopular && <div className='PM_Plan_Chip Fill'><Image src={WhatshotIcon} />Most Popular</div> }
                    {item.save && <div className='PM_Plan_Chip Outline'>Save {item.saveamount}</div>}
                  </div>
                </div>

                <div className='PM_Plan_Right_Col'>
                  <div className='PM_SelectedButton'>
                    <span className='PM_select'>Select <CheckCircleRoundedIcon /></span>
                    <span className='PM_selected'>Selected <CheckCircleRoundedIcon /></span>

                  </div>
                </div>

              </div>
            </ToggleButton>
          ))}


        </ToggleButtonGroup>
      </div>

      <div className='PM_Divider PM_DividerFullWidth'></div>

      <div className='PM_ShoppingCartCheckboutButton'>
        <Buttons
          label="Update Cart"
          buttonColor="#FF6200"
          border="#FF6200 1px solid"
          color="#fff"
          width="100%"
          height="56px"
          fontSize="14px"
        //onClick={handleOpenPaymentDrawer}
        />
      </div>


    </>
  );
}
